import Ngo from "../../models/Ngo";

export interface ngoStateInterface {
  ngos: Ngo[];
  lastCursor: string;
  loading: boolean;
}

const initState: ngoStateInterface = {
  ngos: [],
  lastCursor: "",
  loading: false,
};

const ngoReducer: any = (state = initState, action: any) => {
  switch (action.type) {
    case "UPDATE_NGO_LIST":
      return {
        ...state,
        ngos: action.payload.ngos,
        lastCursor: action.payload.lastCursor,
      };
    case "UPDATE_NGO_LOADING":
      return {
        ...state,
        loading: action.payload.loading,
      };
    default:
      return state;
  }
};

export default ngoReducer;
